var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7774 23.0469H28.2532V1.95312C28.2532 1.43512 28.0432 0.938339 27.6695 0.572057C27.2957 0.205775 26.7888 0 26.2602 0C25.7316 0 25.2247 0.205775 24.851 0.572057C24.4772 0.938339 24.2672 1.43512 24.2672 1.95312V23.0469H2.74298C2.21441 23.0469 1.70749 23.2526 1.33373 23.6189C0.959975 23.9852 0.75 24.482 0.75 25C0.75 25.518 0.959975 26.0148 1.33373 26.3811C1.70749 26.7474 2.21441 26.9531 2.74298 26.9531H24.2672V48.0469C24.2672 48.5649 24.4772 49.0617 24.851 49.4279C25.2247 49.7942 25.7316 50 26.2602 50C26.7888 50 27.2957 49.7942 27.6695 49.4279C28.0432 49.0617 28.2532 48.5649 28.2532 48.0469V26.9531H49.7774C50.306 26.9531 50.8129 26.7474 51.1867 26.3811C51.5604 26.0148 51.7704 25.518 51.7704 25C51.7704 24.482 51.5604 23.9852 51.1867 23.6189C50.8129 23.2526 50.306 23.0469 49.7774 23.0469Z",
    fill: "#48ACB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.87f364db00bda2f22339e6a479bda420.svg";
export { ForwardRef as ReactComponent };